import { strLang } from "../functions/strLang";
import { useEffect, useRef, useState } from "react";

//import HomeIcon from "@mui/icons-material/Home";
import MapIcon from "@mui/icons-material/Map";
import People from "@mui/icons-material/People";
//import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import PublicIcon from "@mui/icons-material/Public";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
//import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
// import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import MoodIcon from "@mui/icons-material/Mood";
import MenuButton from "./components/Button";
import Territories from "../Territories/Territories";
import { emptys, inputParams, user, warningAlerts } from "../data/main";
import { getMainInfo } from "../services/menu";
import Search from "../Search/Search";
import TheMap from "../TheMap/TheMap";
import TheGroups from "../TheGroups/TheGroups";
import Schedule from "../Schedule/Schedule";
import Settings from "../Settings/Settings";
import { getCurrentDate } from "../utilities/getCurrentDate";
import { sendPostServices } from "../services/services";
import { writeGroupAvatars } from "../components/writeGroupAvatars";
import { screensList } from "../data/screensList";
import { colorsList } from "../data/colorsList";
import { eventsImages } from "../data/eventsData";
import { saveEventSeen, eventIsShowed } from "../functions/warningFunctions";

var allAddrs = [];
var counter = true;
var gpscounter = true;
let mainCoords = false;
let searchEvents = true;

export default function useMenu({ logout, login }) {
  // const [mainCoords, setMainCoords] = useState(false);
  const [syncData, setSyncData] = useState({ avatars: [], events: [] });
  const [allMaps, setAllMaps] = useState([]);
  const [eventsData, setEventsData] = useState([]);
  const [terGroups, setTerGroups] = useState([]);
  const [mapData, setMapData] = useState(false);
  const [addresses, setAddresses] = useState(false);
  const [users, setUsers] = useState([]);
  const [showBlack, setShowBlack] = useState(false);
  const [onClickMain, setOnClickMain] = useState(false);
  const [avatar, setAvatar] = useState(Number(localStorage.getItem("avatar")));
  const [btnAvatar, setBtnAvatar] = useState(
    Number(localStorage.getItem("avatar"))
  );

  // const [heading, setHeading] = useState(0);
  // const [permissionGranted, setPermissionGranted] = useState(false);
  const [dialogStatus, setDialogStatus] = useState([false, false, {}]);
  const [msgInfo, setMsgInfo] = useState({ type: "", label: "" });

  const [userName, setUserName] = useState(user.name);
  const name = useRef();

  const inputList = [
    {
      ref: name,
      placeholder: strLang("name"),
      value: userName,
      change: (e) => setUserName(e.target.value),
      maxLength: inputParams.userName.maxLength,
      inputStyle: { width: 110, justifyItems: "center" },
    },
  ];

  const [menu, setMenu] = useState(screensList);

  const closeSession = () => {
    // localStorage.clear()
    localStorage.removeItem("token");
    localStorage.removeItem("code2");
    localStorage.removeItem("rol");
    localStorage.removeItem("logged");
    localStorage.removeItem("day");
    localStorage.removeItem("id");
    logout();
  };

  const openDialog = (type) => {
    if (type === "mood") {
      if (userName !== user.name) {
        setUserName(user.name);
      }
      setDialogStatus([true, false, {}]);
    } else if (type === "logout") {
      openMsg(type);
    }
  };

  const closeDialog = () => setDialogStatus([false, false, {}]);
  const openMsg = (type) => setDialogStatus([dialogStatus[0], type, {}]);
  const closeMainMsg = () => setDialogStatus([dialogStatus[0], false, {}]);

  const closeEventMsg = () => {
    saveEventSeen({
      id: eventsData[0].ID,
      date: eventsData[0].EDATE,
    });
    setEventsData([]);
  };

  const msgType = {
    warning: {
      type: "warning",
      label: strLang("updateNameMsg", false, {
        min: inputParams.userName.minLength,
        max: inputParams.userName.maxLength,
      }),
    },
    noSpecial: {
      type: "warning",
      label: strLang("noSpecialAllowed"),
    },
    loading: {
      type: "loading",
    },
    error: {
      type: "error",
      label: strLang("netWorkError"),
    },
    genWarning: {
      type: "warning",
      label: msgInfo.label,
    },
    enterEditor: {
      type: "warning",
      label: strLang("enterEditor"),
    },
    custom: { ...dialogStatus[2] },
    eventMsg:
      eventsData.length > 0
        ? {
            type: "event",
            eventId: eventsData[0].ETYPE,
            title: emptys.includes(eventsData[0].NAME)
              ? strLang(eventsImages["v" + eventsData[0].ETYPE].title)
              : eventsData[0].NAME,
            intro:
              eventsData[0].OBSER !== ""
                ? eventsData[0].EUSER + strLang("says")
                : strLang("saidBy") + eventsData[0].EUSER,
            label: eventsData[0].OBSER,
            buttons: [
              {
                label: strLang("close"),
                func: closeEventMsg,
              },
            ],
          }
        : {},
    logout: {
      type: "logout",
      label: strLang("wantExit"),
      buttons: [
        { label: strLang("exit"), func: closeSession },
        {
          label: strLang("cancel"),
          func: closeMainMsg,
          color: colorsList.darkGrey,
        },
      ],
    },
  };

  const switchBox = (newValue) => {
    let tMenu = { ...menu };
    for (const key of Object.keys(tMenu)) {
      tMenu[key].width = 0;
    }
    tMenu[newValue].width = 100;
    localStorage.setItem("menu", newValue);
    setMenu({ ...tMenu });
  };

  const menuColor = (o) => {
    return menu[o].width === 100 ? menu[o].color : "gray";
  };

  const writeButton = (start) =>
    menuOptions
      .filter((e) => !e.inner)
      .slice(start, start + 2)
      .map((e, index) => (
        <MenuButton
          key={index}
          Element={e.Elem}
          onClick={() => {
            switchBox(e.id);
          }}
          sx={{ color: menuColor(e.id) }}
        />
      ));

  const getApiData = async (tempData, renew = true) => {
    if (localStorage.getItem("logged")) {
      if (tempData.type === "sync") {
        tempData.ter = user.ter;
      }

      if (tempData.type === "map") {
        if (localStorage.getItem("activityCode")) {
          tempData.groupId = localStorage.getItem("activityCode");
        } else {
          tempData.findActivity = true;
        }
      }

      // console.log("tempData", tempData);
      const response = await getMainInfo(tempData);

      // console.log("api response: ", response);

      switch (tempData.type) {
        case "all":
          response.maps.map((o) => {
            o.FLAGS = response.points.filter(
              (v) => String(v.TER) === String(o.ID) && Number(v.SEC) === 0
            ).length;
            let _addrs = response.address.filter(
              (v) => String(v.IDTER) === String(o.ID)
            );
            o.NP = response.points.filter(
              (v) => String(v.TER) === String(o.ID) && v.LAT2 && v.LON2
            ).length;
            /*o["POINTS"] = response["points"].filter(
              (v) =>
                String(v.TER) === String(o.ID) && v.LAT2 && v.LON2 && v.SEC > 0
            ).length;*/
            o.TOTAL = _addrs.length;
            o.NOTES = response.address.filter(
              (v) => String(v.IDTER) === String(o.ID) && v.NOTAS.length > 0
            ).length;
            o.HECHOS = _addrs.filter((o) => o.EST > 0).length;
            let boxhist = {};
            response.historial
              .filter((v) => String(v.TER) === String(o.ID))
              .map((h) => {
                let ddd = h.FECHA.split(" ");
                ddd[0] = ddd[0].split("-");
                let _idx = "m" + (Number(ddd[0][1]) - 1).toString();
                let _idx2 = Number(ddd[0][2]);
                if (!boxhist[_idx]) {
                  boxhist[_idx] = [];
                }
                if (!boxhist[_idx][_idx2]) {
                  boxhist[_idx][_idx2] = [];
                }

                boxhist[_idx][_idx2].push({
                  DATE: ddd[0].join("-"),
                  HOUR: ddd[1],
                  PER: h.PER,
                  STA: h.STA,
                  POS: Math.round((Number(ddd[0][2]) * 100) / 31),
                });
                return true;
              });

            o.HISTORIAL = boxhist;
            o.EVENTS = response.events.some((h) => h.TER === o.ID);
            return true;
          });
          allAddrs = response.address;

          setAllMaps([
            ...response.maps
              .sort((a, b) => (a.NOM < b.NOM ? -1 : a.NOM > b.NOM ? 1 : 0))
              .map((e) => {
                try {
                  if (e.LIMITES !== "") {
                    e.LIMITES = JSON.parse(`[${e.LIMITES}]`);
                  }
                } catch (error) {
                  e.LIMITES = [];
                }
                return { ...e };
              }),
          ]);
          setAddresses(response.address);
          setTerGroups(
            response.ter_groups.sort((a, b) =>
              a.name < b.name ? -1 : a.name > b.name ? 1 : 0
            )
          );

          response.users.map((o) => {
            let tname = response.maps.filter(
              (v) => Number(v.ID) === Number(o.TER)
            );
            let tavar = syncData.avatars.filter(
              (v) => Number(v.ORD) === Number(o.ORD)
            );
            if (tname.length > 0) {
              o.TERNAME = tname[0].NOM;
            } else {
              o.TERNAME = "";
            }
            if (tavar.length > 0) {
              o.ACTIVE = true;
            } else {
              o.ACTIVE = false;
            }
            return true;
          });
          setUsers(response.users);
          break;
        case "map":
          response.address.sort((a, b) => a.PP - b.PP);
          user.ter = tempData.code;
          user.tername = tempData.name;
          if (response.limits.length > 0) {
            user.date = response.limits[0].MDATE;
          }
          if (response.activity_code) {
            localStorage.setItem("activityCode", response.activity_code);
          }

          setMapData({
            id: tempData.code,
            title: tempData.name,
            mapTile: tempData.code === "all" ? "" : response.limits[0].TILE,
            centerpoint: tempData.point,
            address: response.address,
            points: response.points,
            limits: response.limits,
            // events: response.events,
            sections: response.sections,
            date: response.limits[0]?.MDATE ?? false,
            renew,
            fromMap: tempData.fromMap,
          });
          break;
        case "sync":
          if (response) {
            let tempLive = false;
            if (
              response.avatars &&
              JSON.stringify(syncData.avatars) !==
                JSON.stringify(response.avatars)
            ) {
              tempLive = { avatars: [...response.avatars] };
            }

            if (
              response.events &&
              JSON.stringify(syncData.events) !==
                JSON.stringify(response.events)
            ) {
              if (tempLive) {
                tempLive.events = [...response.events];
              } else {
                tempLive = { events: [...response.events] };
              }
              if (response.events.length > 0 && searchEvents) {
                setEventsData([
                  ...response.events.filter(
                    (h) =>
                      h.EDATE.includes(getCurrentDate()) &&
                      (!warningAlerts[user.id] ||
                        !warningAlerts[user.id]?.events ||
                        warningAlerts[user.id]?.events[h.ID] !== h.EDATE) &&
                      !eventIsShowed(h.ID, h.EDATE)
                  ),
                ]);
              }
            }
            if (tempLive) {
              setSyncData({ ...syncData, ...tempLive });
            }

            if (user.ter > 0 && user.date !== response.date) {
              getApiData(
                {
                  type: "map",
                  code: user.ter,
                  name: user.tername,
                  point: false,
                },
                false
              );
            }
            setTimeout(() => {
              getApiData(tempData);
            }, 5000);
          } else {
            setTimeout(() => {
              getApiData(tempData);
            }, 20000);
          }
          break;
        default:
          break;
      }
    }
    return true;
  };

  const openMap = (data) => {
    const { id, name, point, screen, fromMap } = data;
    if (id !== "all") {
      user.ter = id;
      localStorage.setItem("mapid", id);
      localStorage.setItem("mapname", name);
    }
    getApiData({
      type: "map",
      code: id,
      name,
      point,
      group: id === "all" ? localStorage.getItem("code2") : false,
      fromMap,
    });

    if (screen) {
      switchBox(screen);
    }
  };

  const reloadMap = () => {
    getApiData({
      type: "all",
      code: localStorage.getItem("code2"),
      maincode: localStorage.getItem("code"),
      id: localStorage.getItem("id"),
    });
  };

  const updateMap = (id, points, addrs) => {
    if (!isNaN(id)) {
      let tempMaps = allMaps;
      allAddrs = allAddrs.filter((o) => o.IDTER != id).concat(addrs);
      let index = tempMaps.findIndex((o) => o.ID == id);
      tempMaps[index].FLAGS = points.filter((o) => Number(o.SEC) === 0).length;
      tempMaps[index].NP = points.filter((o) => o.LAT2 && o.LON2).length;
      tempMaps[index].TOTAL = addrs.length;
      tempMaps[index].NOTES = addrs.filter((o) => o.NOTAS.length > 0).length;
      tempMaps[index].HECHOS = addrs.filter((o) => o.EST > 0).length;
      setAllMaps([...tempMaps]);
      setAddresses([...allAddrs]);
    }
  };

  const sendPosition = async (pos) => {
    try {
      let sendPositionPayload = {
        type: "pos",
        id: localStorage.getItem("id"),
        lat: pos[0],
        lng: pos[1],
        date: getCurrentDate(),
      };
      const response = await sendPostServices(sendPositionPayload);
      if (!response.success) {
        console.log("sendPosition fail");
      }
    } catch (error) {
      console.log("sendPosition error: ", error);
    }

    setTimeout(() => {
      counter = true;
    }, 3000);
  };

  const gpsOk = (position) => {
    const { latitude, longitude } = position.coords; //accuracy, altitude, heading, speed
    if (
      latitude !== mainCoords.latitude &&
      longitude !== mainCoords.longitude &&
      counter
    ) {
      counter = false;
      sendPosition([latitude, longitude]);
    }
    if (gpscounter) {
      gpscounter = false;
      mainCoords = position.coords;
      setTimeout(() => {
        gpscounter = true;
      }, 1000);
    }

    //if (target.latitude === crd.latitude && target.longitude === crd.longitude) {
    //  navigator.geolocation.clearWatch(id);
    //}
  };

  const gpsError = (err) => {
    console.error(`ERROR(${err.code}): ${err.message}`);
  };

  useEffect(() => {
    setOnClickMain(showBlack);
  }, [showBlack]);

  useEffect(() => {
    const mpInit = async () => {
      if (
        [null, "null"].includes(localStorage.getItem("avatar")) ||
        localStorage.getItem("day") !== getCurrentDate()
      ) {
        closeSession();
        return;
      }

      if (localStorage.getItem("rol") > 0) {
        openMsg("enterEditor");
      }

      try {
        let getWarningAlerts = localStorage.getItem("warningAlerts");
        if (![null, "null"].includes(getWarningAlerts)) {
          getWarningAlerts = JSON.parse(getWarningAlerts);
          Object.keys(getWarningAlerts).forEach((key) => {
            warningAlerts[key] = getWarningAlerts[key];
          });
        }
      } catch (error) {
        console.error("Error parsing warningAlerts:", error);
      }

      navigator.geolocation.watchPosition(gpsOk, gpsError, {
        //let gpsID =
        enableHighAccuracy: true,
        timeout: 1000,
        maximumAge: 0,
      });

      /*if (window.DeviceOrientationEvent) {
              // Listen for the deviceorientation event and handle the raw data
              window.addEventListener('deviceorientation', (event) => {
                var compassdir;
                var conver
                if(event.webkitCompassHeading) {
                // Apple works only with this, alpha doesn't work
                compassdir = event.webkitCompassHeading; 
                conver=compassdir * Math.PI / -180;
                } else {
                  compassdir = event.alpha;
                  conver=compassdir * Math.PI / 180;
                }
                //alert(conver)
              //   if (activeLook===3) {
              //     mainView.animate({rotation: conver, duration: 500})
              //   }
              });
          }*/

      await getApiData({
        type: "all",
        code: localStorage.getItem("code2"),
        maincode: localStorage.getItem("code"),
        id: localStorage.getItem("id"),
      });
      await getApiData({
        type: "sync",
        code: localStorage.getItem("code"),
        maincode: localStorage.getItem("code2"),
        id: localStorage.getItem("id"),
        day: localStorage.getItem("day"),
      });
      if (
        localStorage.getItem("mapid") &&
        localStorage.getItem("menu") === "map" &&
        localStorage.getItem("mapid") !== "undefined"
      ) {
        openMap({
          id: localStorage.getItem("mapid"),
          name: localStorage.getItem("mapname"),
          point: "reload",
          screen: "map",
        });
      }
      /* else if (!emptys.includes(localStorage.getItem('menu'))) {
              console.log(localStorage.getItem('menu'))
              switchBox(localStorage.getItem('menu'))
          }*/
      /*fetch('/mock-geojson-api.json')
            .then(response => response.json())
            .then( (fetchedFeatures) => {
              // parse fetched geojson into OpenLayers features
              //  use options to convert feature from EPSG:4326 to EPSG:3857
              const wktOptions = {
                dataProjection: 'EPSG:4326',
                featureProjection: 'EPSG:3857'
              }
              const parsedFeatures = new GeoJSON().readFeatures(fetchedFeatures, wktOptions)
      
              // set features into state (which will be passed into OpenLayers
              //  map component as props)
      
              navigator.geolocation.getCurrentPosition(function (position) {
                parsedFeatures[0]['coords'] = {
                  lat:position.coords.latitude,
                  lon:position.coords.longitude
                }
                setFeatures(parsedFeatures)
              });
            })*/
    };
    mpInit();
  }, []);

  // useEffect(() => {
  //   const handleOrientation = (event) => {
  //     const alpha = event.alpha;
  //     setHeading(alpha?.toFixed(2));
  //   };

  //   const setupListener = () => {
  //     window.addEventListener("deviceorientation", handleOrientation, true);
  //   };

  //   // iOS requiere solicitud de permiso a partir de iOS 13+
  //   if (
  //     typeof DeviceOrientationEvent !== "undefined" &&
  //     typeof DeviceOrientationEvent.requestPermission === "function"
  //   ) {
  //     DeviceOrientationEvent.requestPermission()
  //       .then((response) => {
  //         if (response === "granted") {
  //           setPermissionGranted(true);
  //           setupListener();
  //         }
  //       })
  //       .catch(console.error);
  //   } else {
  //     // Android y navegadores que no requieren permiso
  //     setPermissionGranted(true);
  //     setupListener();
  //   }

  //   return () => {
  //     window.removeEventListener("deviceorientation", handleOrientation);
  //   };
  // }, []);

  const updateName = async () => {
    try {
      const tempName = userName.trim();
      if (
        tempName.length > inputParams.userName.maxLength ||
        tempName.length < inputParams.userName.minLength
      ) {
        openMsg("warning");
      } else if (/[\p{P}\p{S}]/u.test(tempName)) {
        openMsg("noSpecial");
      } else {
        openMsg("loading");
        let updateNamePayload = {
          type: "updateName",
          id: localStorage.getItem("id"),
          name: tempName,
          avatar,
        };
        // console.log("updateNamePayload", updateNamePayload);
        const response = await sendPostServices(updateNamePayload);
        // console.log("response", response);
        if (response.status) {
          localStorage.setItem("avatar", avatar);
          localStorage.setItem("name", tempName);
          user.name = tempName;
          user.avatar = avatar;
          setBtnAvatar(avatar);
          closeDialog();
        } else {
          openMsg("error");
        }
      }
    } catch (error) {
      console.log("updateName error: ", error);
    }
  };

  const writeAvatars = () => (
    <div style={{ padding: 10 }}>
      {writeGroupAvatars(avatar, setAvatar, 0.75)}
    </div>
  );

  const openMainMsg = (data, custom = false) => {
    if (custom) {
      setDialogStatus([
        false,
        "custom",
        {
          ...custom,
          buttons: Array.isArray(custom.buttons)
            ? [
                ...custom.buttons,
                {
                  label: strLang("cancel"),
                  func: closeMainMsg,
                  color: colorsList.darkGrey,
                },
              ]
            : [],
        },
      ]);
    } else {
      setMsgInfo(data);
      openMsg("genWarning");
    }
  };

  const menuOptions = [
    { id: "schedule", Elem: CalendarMonthIcon },
    { id: "territories", Elem: MapIcon },
    {
      Elem: MoodIcon,
      func: "mood",
      inner: true,
      color: screensList.mood.color,
    },
    {
      id: "groups",
      Elem: People,
      inner: true,
      color: screensList.groups.color,
    },
    {
      id: "settings",
      Elem: SettingsIcon,
      inner: true,
      color: screensList.settings.color,
    },
    {
      Elem: LogoutIcon,
      func: "logout",
      inner: true,
      color: screensList.logout.color,
    },
    { id: "addresses", Elem: LocationOnIcon },
    { id: "map", Elem: PublicIcon },
  ];

  const screens = [
    {
      id: "territories",
      Comp: Territories,
      maps: allMaps,
      openMap,
      reloadMap,
      terGroups,
      iconColor: screensList.territories.color,
    },
    {
      id: "addresses",
      Comp: Search,
      addresses,
      openMap,
      reloadMap,
      iconColor: screensList.addresses.color,
    },
    {
      id: "map",
      Comp: TheMap,
      updateMap,
      openMap,
      userAvatar: avatar,
      mainCoords,
      mapData,
      allMaps,
      allAddresses: addresses,
      syncData,
      closeMainMsg,
      // heading,
      openMainMsg,
      iconColor: screensList.map.color,
    },
    {
      id: "groups",
      Comp: TheGroups,
      mapData,
      // allMaps,
      avatars: syncData.avatars,
      openMap,
      openMainMsg,
      iconColor: screensList.groups.color,
    },
    {
      id: "schedule",
      Comp: Schedule,
      login,
      maps: allMaps,
      users,
      openMap,
      openMainMsg,
      iconColor: screensList.schedule.color,
    },
    {
      id: "settings",
      Comp: Settings,
      users,
      setGlobalUsers: setUsers,
      iconColor: screensList.settings.color,
    },
  ];

  const avaButtons = [
    { label: strLang("update"), func: updateName, width: 80 },
    {
      label: strLang("cancel"),
      func: closeDialog,
      width: 80,
      color: colorsList.darkGrey,
    },
  ];

  return {
    menu,
    showBlack,
    setShowBlack,
    menuOptions,
    writeButton,
    switchBox,
    screens,
    onClickMain,
    setOnClickMain,
    dialogStatus,
    closeDialog,
    openDialog,
    avatar,
    btnAvatar,
    setAvatar,
    inputList,
    avaButtons,
    closeMainMsg,
    msgType,
    writeAvatars,
    eventsData,
  };
}
